import { createI18n } from "vue-i18n";
import ruCalculators from "./locales/ru/calculators.json";
import ukCalculators from "./locales/uk/calculators.json";
import enCalculators from "./locales/en/calculators.json";
import ruCommon from "./locales/ru/common.json";
import ukCommon from "./locales/uk/common.json";
import enCommon from "./locales/en/common.json";
import ruFaq from "./locales/ru/faq.json";
import ukFaq from "./locales/uk/faq.json";
import enFaq from "./locales/en/faq.json";
import ruAuth from "./locales/ru/auth.json";
import ukAuth from "./locales/uk/auth.json";
import enAuth from "./locales/en/auth.json";

export const i18n = createI18n({
  legacy: false,
  locale: "ru",
  fallbackLocale: "en",
  messages: {
    ru: {
      ...ruCommon,
      calculators: ruCalculators,
      faq: ruFaq,
      auth: ruAuth,
    },
    en: {
      ...enCommon,
      calculators: enCalculators,
      faq: enFaq,
      auth: enAuth,
    },
    uk: {
      ...ukCommon,
      calculators: ukCalculators,
      faq: ukFaq,
      auth: ukAuth,
    },
  },
});
